module.exports = __webpack_public_path__ + "static/media/icon-save.76fc359d.svg";